<template>
    <div class="marginCon">
        <Card>
           
            <div v-if="offModel">
                <div class="top" v-if='roleType==1'>
                    <Button type="success" class="addButton"  @click="addData(1)" style="margin-right:8px;">{{$t("appVersion.addButton")}}</Button>
                </div>
                 <!-- 搜索 -->
                <div class="search-div">
                   <RadioGroup v-model="searchObj.os" @on-change='searchItem'>
                        <Radio label="1">
                            <Icon type="logo-android"></Icon>
                            <span>Android</span>
                        </Radio>
                        <Radio label="2">
                            <Icon type="logo-apple"></Icon>
                            <span>Apple</span>
                        </Radio>
                    </RadioGroup>
                </div>

                <Table max-height='750'  style="width: 100%;margin-top: 30px;" :columns="titleName" :data="tableList.tableData"  ref="selection" @on-sort-change="sortCustom" :loading='loading'></Table>
            </div>

             <!-- 更改状态 -->
            <DeleteDialog ref="changeChild" @ievent = "ievent"   :title='$t("appVersion.deletModel.changeTitle")' :cont='$t("appVersion.deletModel.changeCont")'></DeleteDialog>

            <!-- 编辑 / 添加  模态框组件 -->
             <ModelBox :showModel.sync="addBox.showModel" :offModel.sync='offModel' :fn="addBox.callbackFn" :type="1"  :editFormData="addBox.editFormData"></ModelBox>

        </Card>
    </div>
</template>

<script>

import common from '@/common/common.js';
import moment from 'moment';
import DeleteDialog from '../common/deleteModel.vue'; // 引入删除弹框组件
import ModelBox from './component/verAddModel.vue';
import { mapState } from 'vuex'

    export default {
        name: "firmwareVersion",
        components: {
            ModelBox,
            DeleteDialog
        },
        data(){
            return{
                type:1,
                loading: true,
                offModel: true,
                page:{//分页排序
                    total:0,//总条数
                    pageSize:15,//每页条数
                    current:1,//当前页
                    key:'created_at',
                    order:'desc'
                },
                addBox:{//规格弹框组-新增
                    showModel:false,//弹框开关
                    callbackFn:()=>{}, //弹框的回调函数
                    editFormData:{},//编辑时传入的现有数据
                },
                searchObj:{
                    os:'1'
                },
                tableList:{
                    tableData:[],
                    hasSelectData:{}
                },
                
               
            }
        },
        computed:{
            ...mapState(['local','uInfo','selectId']),
            roleType(){
	             let res = '2'
	             if(this.$store.state.uInfo && this.$store.state.uInfo.roleType){
	            	 res = this.$store.state.uInfo.roleType
	             }
	             return res
	        },
           Operation(){
                return {
		            	title: this.$t('productPage.titleName.Operation'),
                        'title-zh-CN':'操作',
                        'title-en-US':'Operation',
                        // fixed:'right',
		            	width:120,
                        key: "Operation",
		            	render: (h, params) => {
                            let that = this
                            return h('div',{
                                style:{
                                    display:'flex',
                                    'justify-content':'center'
                                }
                            },[
                                h('Button',{
		            	              props: {
                                          type: "primary",
                                          size: 'small'
                                      },
                                      attrs:{
                                          disabled:params.row.status==2?true:false
                                      },
                                      style:{
                                        'margin-right':'8px'
                                      },
		            	              on: {
		            	                  click: () => { 
                                               this.tableList.hasSelectData = params.row
                                               this.changeData()
                                           }
		            	              }
		            	          },that.$t("appVersion.Expire"))
                            ])
		            	}
		        }
            },
           titleName(){
              return [
                    {
                        title:this.$t('appVersion.titleName.id'),
                        'title-zh-CN':'应用编号',
                        'title-en-US':'Id',
                        key: 'id',
                        minWidth: 120,
                        sortable: true,
                        tree: true
                    },
                    {
                        title:this.$t('appVersion.titleName.version'),
                        'title-zh-CN':'版本号',
                        'title-en-US':'Version',
                        key: 'version',
                        minWidth: 100
                    },
                    {
                        title:this.$t('appVersion.titleName.releaseDate'),
                        'title-zh-CN':'发布日期',
                        'title-en-US':'Release date',
                        key: 'releaseDate',
                        minWidth: 180,
                        render:(h, params)=>{
                            let stext = moment(params.row.releaseDate).format('YYYY-MM-DD HH:mm:ss')
                             return h('div',stext || '')
                        }
                    },
                   {
                        title:this.$t('appVersion.titleName.releaseType'),
                        'title-zh-CN':'发布类型',
                        'title-en-US':'Release type',
                        key: 'releaseType',
                        minWidth: 130,
                        render:(h, params)=>{
                             let obj = {'1':this.$t("selectList.releaseTypeList.beta"),'2':this.$t("selectList.releaseTypeList.release")}
                             let stext = obj.hasOwnProperty(params.row.releaseType) ? obj[params.row.releaseType] : params.row.releaseType
                             return h('div',stext || '')
                        }
                    },
                    {
                        title:this.$t('appVersion.titleName.status'),
                        'title-zh-CN':'app状态',
                        'title-en-US':'Status',
                        key: 'status',
                        minWidth: 110,
                        render:(h, params)=>{

                             let obj = {'1':this.$t("selectList.appStatusList.Online"),'2':this.$t("selectList.appStatusList.Expired")};
                             let styleObj = {'1':'color:#19be6b','2':''}
                             let stext = obj.hasOwnProperty(params.row.status) ? obj[params.row.status] : params.row.status
                             let style = obj.hasOwnProperty(params.row.status) ? styleObj[params.row.status] : {}
                             return h('div',{
                                 style:style
                             },stext || '')
                        }
                    },
                    {
                        title:this.$t('appVersion.titleName.fileName'),
                        'title-zh-CN':'包文件',
                        'title-en-US':'Apk file ',
                        key: 'fileName',
                        minWidth: 240
                    },
                    {
                        title:this.$t('appVersion.titleName.updateInformation'),
                        'title-zh-CN':'更新信息',
                        'title-en-US':'Update information',
                        key: 'updateInformation',
                        resizable: true,
                        // width:160,
                        minWidth: 300,
                        render:(h, params)=>{
                            let flag = params.row.updateInformation;
                            let flag1 = flag.slice(2,flag.length-2);
                            let arr = flag1.split('&&')
                            let stext = ''
                            arr.map((item,index)=>{
                                let indexflag = item.indexOf('&')
                                if((this.local=='zh-CN' && item.slice(0,indexflag)=='zh') || (this.local=='en-US' && item.slice(0,indexflag)=='en')){
                                    stext = (item.split('&'))[1]
                                }
                               
                            })
                          
                            return h('div',{
                                attrs:{
                                    title:stext
                                }
                            },stext || '')
                        }
                    },
                    {
                        title:this.$t('appVersion.titleName.innerLink'),
                        'title-zh-CN':'内测链接',
                        'title-en-US':'Inner Link',
                        key: 'innerLink',
                        minWidth: 300
                    }
                ]

           } ,
        },
        created (){
            if(this.roleType==1){
               this.titleName.push(this.Operation)
            }
            this.getData()
        },

        methods: {
            addData(type) {  //添加或编辑数据
                this.addBox.showModel = true
                this.offModel = false
                this.type = type
                this.addBox.editFormData.os = this.searchObj.os
                this.addBox.callbackFn = () => {//回调处理
                    //重新载入
                    // this.clearbtnStatus()
                    this.addBox.showModel = false;
                    this.getData();
                }
            },
            changeData() {// 解绑
                if(this.roleType==2) return
                this.$refs.changeChild.showit();
            },
            ievent() {// 解绑
                if(this.roleType==2) return
                this.axios.post(this.config.urlArray.appsSet, {id:this.tableList.hasSelectData.id,dealerId:this.selectId}).then((result)=>{
                    common.ajaxMsg(result.data,true,()=>{
                        this.$refs.changeChild.recancel();
                        this.getData();
                    })
                }).catch((err)=>{
                    // common.msg('error','error')
                })
            },
            searchItem(){
                this.loading = true
                this.page.current = 1
                this.page.pageSize = 15
                this.getData()
            },
            getData(){ //获取数据
                let getData = {
                    dealerId:this.selectId,
                    page:this.page.current,
                    limit:this.page.pageSize,
                    sort:this.page.key,
                    asc:this.page.order,
                    ...this.searchObj
                    
                }
                this.axios.post(this.config.urlArray.apps,getData).then((result) => {
                    common.ajaxMsg(result.data,false,()=>{
                        let resData = result.data.data
                        //处理数组
                        if(resData){
                            this.tableList.tableData = resData  //渲染数据
                            this.page.total = result.data.data.length
                            this.loading = false
                        }
                    });
                }).catch((err) => {
                    // common.msg('error','获取失败',()=>{})
                });
            },
            sortCustom (data) {//自定义排序
                this.page.key = data.key
                this.page.order = data.order
                this.getData()
            },
            changePage (nowpage) {//切换分页
                this.page.current = nowpage
                this.getData()
            },
            changeSize (nowSize) {//切换每页显示条数
                this.page.pageSize = nowSize
                this.page.current = 1
                this.getData()
            }
        }
    }
</script>
<style lang="less" scoped>
/deep/ .ivu-table-fixed-right{
    height: 100%;
}
.top{
    margin-top: 10px;
    margin-bottom: 20px;
}
</style>


